export default "__VITE_PUBLIC_ASSET__56e643f1__"